import React, {
  useState,
  useEffect,
  useMemo,
  useContext,
  useLayoutEffect,
} from "react";

import {createRoot} from "react-dom/client";

import {
  Route,
  BrowserRouter,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";

import {StylesProvider} from "@mui/styles";
import {ThemeProvider, createTheme} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Flow from "./pages/Flow";
import Login from "./pages/Login";
import Projects from "./pages/Projects";
import Home from "./pages/Home";
import Stats from "./pages/Stats";
import Creators from "./pages/creators";

function App() {
  const theme = useMemo(
    () =>
      createTheme({
        typography: {},
        palette: {
          primary: {main: "#81BE49"},
          secondary: {main: "#0096B8"},
          mode: "dark",
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              body: {
                // background: "#1F261B",
              },
              "*[data-com-onepassword-filled]": {
                color: "white !important",
              },
            },
          },
        },
      }),
    []
  );

  return (
    <StylesProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/flow" element={<Flow />} />
            <Route exact path="/projects" element={<Projects />} />
            <Route exact path="/creators" element={<Creators />} />
            <Route exact path="/stats" element={<Stats />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </StylesProvider>
  );
}

const container = document.getElementById("app");
const root = createRoot(container);
root.render(<App />);
